"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverallBufferedPercent = getOverallBufferedPercent;
exports.getOverallPlayedPercent = getOverallPlayedPercent;
exports.geOverallBufferLength = geOverallBufferLength;
exports.getNearestBufferSegmentInfo = getNearestBufferSegmentInfo;
function getOverallBufferedPercent(buffered) {
  var currentTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!buffered || !buffered.length || !duration) {
    return 0;
  }

  var info = getNearestBufferSegmentInfo(buffered, currentTime);

  return (info.end / duration * 100).toFixed(1);
}

function getOverallPlayedPercent() {
  var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!duration) {
    return 0;
  }

  return (currentTime / duration * 100).toFixed(1);
}

function geOverallBufferLength(buffered) {
  var size = 0;

  if (!buffered || !buffered.length) {
    return size;
  }

  for (var i = 0; i < buffered.length; i += 1) {
    size += buffered.end(i) - buffered.start(i);
  }

  return size;
}

function getNearestBufferSegmentInfo(buffered, currentTime) {
  var i = 0;

  if (!buffered || !buffered.length) {
    return null;
  }

  while (i < buffered.length - 1 && !(buffered.start(i) <= currentTime && currentTime <= buffered.end(i))) {
    i += 1;
  }

  return {
    start: buffered.start(i),
    end: buffered.end(i)
  };
}
//# sourceMappingURL=video-data.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/utils/video-data.js
// module id = 1235
// module chunks = 1 2 3